import ModalComponent from '@components/modal/Modal.component';
import {Button, Stack} from '@mui/material';
import {executionsService, ExecutionTemplateMail,} from '@store/operations/executions';
import {useSnackbar} from 'notistack';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import SelectComponent from '@components/inputs/select/Select.component';
import {Sizes} from '@constants/sizes.constants';
import {OrganisationType} from '@store/common/organisation.enums';

interface ReminderEmailModalProps {
  handleClose: () => void;
}

const ReminderEmailModal = (props: ReminderEmailModalProps) => {
  const {handleClose} = props;

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const {executionId} = useParams();
  const [templateType, setTemplateType] = useState<ExecutionTemplateMail>(ExecutionTemplateMail.DEFAULT);
  const [audience, setAudience] = useState<OrganisationType>(OrganisationType.SUPPLIER);

  const handleSendMail = () => {
    if (!executionId) return;
    executionsService
      .sendMail(executionId, audience, templateType)
      .pipe()
      .subscribe({
        next: () => {
          enqueueSnackbar(t('operations.executions.success.mailSent'), {variant: 'success'});
          handleClose();
        },
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <ModalComponent
      title={t('operations.executions.reminderEmail.title')}
      aria-label="over-drawer"
      handleClose={handleClose}
      content={
        <Stack width="100%" p="20px" spacing={2} overflow="hidden">

          <SelectComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('global.templateType')}
            placeholder={t('global.select')}
            handleChange={(value) => setTemplateType(value)}
            items={ExecutionTemplateMail.selectItems()}
            value={templateType}
          />

          <SelectComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('global.audience')}
            placeholder={t('global.select')}
            handleChange={(value) => setAudience(value)}
            items={OrganisationType.selectItems()}
            value={audience}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSendMail()}
          >
            {t('global.send')}
          </Button>
        </Stack>
      }
    />
  );
};

export default ReminderEmailModal;
